const l={small:16,large:40};export{l as SizeMap};
